export default __webpack_public_path__ + "915d98e49545d7edb82fac43fd89b428.png";